























































































































































import { apiPageConfigGetTvMallHomeData } from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useLoaded } from '@/hooks'
import { defineTvListeners } from '../utils'
import { devOrProd, prepareData, requiredDeep, Track } from '@/utils'
import { navigateTo } from '@/router'
import { XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: 'TV首页',
        }))

        useLoaded(this.loading, () => this.goToHeader(1))
      }

      // 加载状态
      loading = computed(() => this.apiData.loading)

      apiData = useApi(() =>
        prepareData({
          homeData: apiPageConfigGetTvMallHomeData().then(requiredDeep),
        }),
      )

      homeData = computed(() => this.apiData.data.homeData)

      // 加载推荐数据
      loadRecommendData: XWaterfallLoad = ({ pageNumber }) => {
        return pageNumber === 1 ? this.homeData.value.recommendGoods : []
      }

      // ==== 轮播 ====
      // 轮播自动播放
      bannerAutoplay = ref<number | undefined>(5000)

      // 当前轮播项索引
      currentBannerIndex = ref(0)

      // 轮播项改变时触发
      handleBannerChange = (index: number) => {
        this.currentBannerIndex.value = index
      }

      // ==== 跳转 ====
      // 跳到头部
      goToHeader = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.header as any, index)
      }

      // 跳到轮播
      goToBanner = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.bannerIndicator as any, index)
      }

      // 跳到热销榜单
      goToRank = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.rank as any).$el, index)
      }

      // 跳到分类
      goToCategory = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.category as any).$el, index)
      }

      // 跳到推荐
      goToRecommend = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.recommend as any).$el, index)
      }

      // ==== 监听器 ====
      // 头部监听器
      headerListeners = defineTvListeners<
        '搜索' | '我的订单' | '购物车' | '收藏夹' | '我的券包' | '收货地址'
      >(({ type, item, isLast }) => {
        switch (type) {
          case 'right':
            if (isLast) {
              this.goToHeader(-1)
            }
            break
          case 'down':
            this.goToBanner(0)
            break
          case 'click':
            if (item === '搜索') {
              navigateTo('TvSearchIndex')
            } else if (item === '我的订单') {
              navigateTo('TvOrderIndex')
            } else if (item === '购物车') {
              navigateTo('TvCartIndex')
            } else if (item === '收藏夹') {
              navigateTo('TvUserFavorite')
            } else if (item === '我的券包') {
              dcb.navigateTo({
                url: devOrProd(
                  'https://tv-h5.duotest.cn/app/tv-marketing-coupon-frontend/#/home?isLogin=true',
                  'https://tv-h5.gogpay.cn/tv-marketing-coupon-frontend/#/home?isLogin=true',
                ),
              })
            } else if (item === '收货地址') {
              dcb.navigateTo({
                url: devOrProd(
                  'https://tv-h5.duotest.cn/app/tv-basic/#/address?isLogin=true',
                  'https://tv-h5.gogpay.cn/tv-basic/#/address?isLogin=true',
                ),
              })
            }
            break
          default:
            break
        }
      })

      // 轮播监听器
      bannerListeners = defineTvListeners(
        ({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'focus':
              this.bannerAutoplay.value = undefined
              ;(ctx.$refs.banner as any).swipeTo(index)
              break
            case 'left':
              if (isFirst) {
                this.goToBanner(0)
              }
              break
            case 'right':
              if (isLast) {
                this.goToBanner(-1)
              }
              break
            case 'click':
              dcb.navigateTo({
                url: this.homeData.value.banner[index].targetUrl,
              })
              break
            default:
              break
          }
        },
      )

      // 热销榜单监听器
      rankListeners = defineTvListeners(
        ({ type, isFirst, isLast, index }) => {
          switch (type) {
            case 'focus':
              ctx.$tv.setScrollEl(ctx.$refs.rank, false)
              break
            case 'up':
            case 'down':
              ctx.$tv.resetScrollEl()
              if (type === 'up') {
                this.goToBanner(0)
              } else if (type === 'down') {
                this.goToCategory(0)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToRank(0)
              }
              break
            case 'right':
              if (isLast) {
                this.goToRank(-1)
              }
              break
            case 'click':
              dcb.navigateTo({
                url: this.homeData.value.hotSale[index].targetUrl,
              })
              break
            default:
              break
          }
        },
      )

      // 分类监听器
      categoryListeners = defineTvListeners(
        ({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'up':
              if (index < 5) {
                this.goToRank(0)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToCategory(0)
              }
              break
            case 'right':
              if (isLast) {
                this.goToCategory(-1)
              }
              break
            case 'click':
              dcb.navigateTo({
                url: this.homeData.value.classify[index].targetUrl,
              })
              break
            default:
              break
          }
        },
      )

      // 推荐监听器
      recommendListeners = defineTvListeners(
        ({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'up':
              if (index < 5) {
                this.goToCategory(-1)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToRecommend(0)
              }
              break
            case 'right':
              if ((index + 1) % 5 === 0) {
                this.goToRecommend(index)
              } else if (isLast) {
                this.goToRecommend(-1)
              }
              break
            case 'click':
              dcb.navigateTo({
                url: this.homeData.value.recommendGoods[index].targetUrl,
              })
              break
            default:
              break
          }
        },
      )
    },
)
